import React, { useState, useEffect, useContext, useMemo } from "react";
import {
  CompactCol,
  CustomSLButton,
  FlexRow,
  SmallText,
  UltraMediumText,
  SLGridLayout,
  SLRowLayout,
  SLNotification,
} from "../../components/core/utility";
import { CustomInput, StyledCol, ColumnAlignment, CustomDropdown } from "./AddAVehicle";
import { Input, RadioButtonGroup } from "@vds/inputs";
import { DropdownSelect } from "@vds/selects";
import { Row, Col } from "@vds/grids";
import { Button } from "@vds/buttons";
import styled from "styled-components";
import { ADDRESS_REGEX, ZIP_CODE_LIMIT, ZIP_REGEX } from "../../constants/C4SValidationConstants";
import { css } from "@emotion/react";
import { isEqual, groupBy } from "lodash";
import { validateAddress } from "../../services/C4S Decommission - Replacement/validateAddress";
import { getStatesList } from "../../services/C4S Decommission - Replacement/getStatesList";
import { getCountryList } from "../../services/scheduler/getCountryList";
import { generate } from "shortid";
import { C4SContext } from "../../context/c4sContext";
import useOutsideClick from "../../customHook/use-outside-click";
import { Loader } from "@vds/loaders";

const RadioButtonGroupWrapper = styled.div`
  div[role="radiogroup"] {
    border: 0.0625rem solid #d8dada;
    width: ${(props) => props.$width || "70vmin"};
    margin-bottom: 0.6rem;
    > div > label {
      > div:first-child > div {
        height: 1rem;
        width: 1rem;
        transform: translate(50%, 100%);
      }
      > div:last-child {
        font-size: 12px;
        font-family: Verizon-NHG-eTX;
        padding: 0.313rem 0.5rem;
        > span > span {
          font-size: 14px;
          font-family: Verizon-NHG-eTX;
        }
      }
    }
  }
`;

const InstallationAddressRow = css`
  @media screen and (min-width: 910px) {
    max-width: 37.25rem;
    min-width: 4.125rem;
  }
`;

const WTInstallationAddressRow = css`
  min-width: 105%;
`;

const WTStyledCol = css`
  & div {
    @media screen and (min-width: 1260px) {
      padding-right: 0.3em;
    }
  }
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
`;

const CustomHistoricalLoader = css`
  display: flex;
  flex-direction: row;
  margin-left: 1rem;
  margin-top: 0.5rem;
  div[aria-label="loader overlay"] {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    > div {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  & div {
    padding-left: 0.5rem;
  }
`;

const COUNTRY_ZIP_LIMITS = {
  DEU: [5, 5],
  GBR: [4, 8],
  FRA: [5, 5],
  CAN: [6, 6],
  NLD: [4, 4],
  IRL: [7, 7],
  MEX: [5, 5],
  NZL: [4, 4],
  USA: [5, 5],
  AUS: [4, 4],
  AUT: [4, 4],
  BEL: [4, 4],
  MCO: [5, 5],
  IOM: [4, 8],
};

export const CommonValidateAddress = ({
  address,
  setAddress,
  setLoader = () => {},
  showHistoricalAddressDropdown = false,
  vehicleData = null,
  shippingAddress = "",
  autoValidateShippingAddress = false,
  defaultCountryOnNew = null,
  defaultCountryOnInit = null,
  trackLocusFields = false,
  showTypedAddressOption = true,
  showInternalLoader = false,
  showTitle = true,
  title = "Shipping Address",
  subTitle = "",
  notify: externalNotify = null,
  validAddress = null,
  setValidAddress = null,
  modal = false,
  callBackNotify = null,
  onVerificationComplete = null,
  setModalOpened = null,
  setAlertModal = null,
  onFieldsChanged = null,
  variant = "default",
  styles = {},
}) => {
  const { notification, historicalAddressDetails, countryListDetails, stateListDetails } = useContext(C4SContext);
  const { verified, addressByPass, locationFound, historicalAddress, address1, address2, city, state, zip, country } = address;

  const [isAddressSuggestionShown, setIsAddressSuggestionShown] = useState(false);
  const [isAddressFieldsDisable, setIsAddressFieldsDisable] = useState(showHistoricalAddressDropdown);
  const [suggestedAddress, setSuggestedAddress] = useState({
    address: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  });
  const [isLoading, setInternalLoader] = useState(false);
  const [typedAddress, setTypedAddress] = useState("");
  const [isAddressValidationBtnDisabled, setIsAddressValidationBtnDisabled] = useState(true);
  const [zipCodeLimit, setZipCodeLimit] = useState("");
  const [zipRegex, setZipRegex] = useState("");
  const [selectedAddressType, setSelectedAddressType] = useState("");

  const isEditVehicle = variant === "editVehicle";
  const [originalValues] = useState(() => {
    if (!isEditVehicle) return {};
    const parsed = (() => { const parts = (shippingAddress || "").split(","); let a1="",a2="",c="",s="",z="",co=""; if(parts.length<=6){a1=parts[0]?.trim()||"";c=parts[parts.length-4]?.trim()||"";s=parts[parts.length-3]?.trim()||"";z=parts[parts.length-2]?.trim()||"";co=parts[parts.length-1]?.trim()||"";if(parts.length>5)a2=parts.slice(1,-4).join(",").trim();} return {address1:a1,address2:a2,city:c,state:s,zipCode:z,country:co}; })();
    return { ...parsed, historicalAddress: shippingAddress || "" };
  });
  const [isValidatingHistoricalAddress, setIsValidatingHistoricalAddress] = useState(false);
  const [isValidatingNewAddress, setIsValidatingNewAddress] = useState(false);
  const [handleInvalidAddress, setHandleInvalidAddress] = useState(true);
  const isErrorInAddressFields = useMemo(() => address1.error || address2.error || city.error || state.error || country.error || zip.error, [address1, address2, city, state, country, zip]);

  const handleClickOutside = () => {
    notification?.setNotification(null);
  };
  const clickRef = useOutsideClick(handleClickOutside);

  const notify = (content, type) => {
    if (externalNotify) {
      externalNotify(content, type);
    } else if (modal && callBackNotify) {
      callBackNotify(content, type, true);
    } else {
      notification?.setNotification(
        <SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />
      );
    }
  };

  // ── Utility ────────────────────────────────────────────────────────────

  const splitAddress = (addr) => {
    const parts = addr.split(",");
    let a1 = "", a2 = "", c = "", s = "", z = "", co = "";
    if (parts.length <= 6) {
      a1 = parts[0].trim();
      c = parts[parts.length - 4].trim();
      s = parts[parts.length - 3].trim();
      z = parts[parts.length - 2].trim();
      co = parts[parts.length - 1].trim();
      if (parts.length > 5) a2 = parts.slice(1, -4).join(",").trim();
    }
    return { address1: a1, address2: a2, city: c, state: s, zipCode: z, country: co };
  };

  const handleZipCodeBasedOnCountry = (countryCode) => {
    let zipCodeRegex = ZIP_REGEX, limit = ZIP_CODE_LIMIT;
    if (countryCode) {
      const limits = COUNTRY_ZIP_LIMITS[countryCode];
      zipCodeRegex = new RegExp(`^\\d{${limits[0]},${limits[1]}}$`);
      limit = limits[1];
      if (["GBR", "CAN", "IRL", "NLD", "IOM"].includes(countryCode)) {
        if (countryCode === "IRL") { zipCodeRegex = new RegExp("^[a-zA-Z0-9]{3} [a-zA-Z0-9]{4}$"); limit = limits[1] + 1; }
        if (countryCode === "CAN") { zipCodeRegex = new RegExp("^[a-zA-Z]\\d[a-zA-Z] \\d[a-zA-Z]\\d$"); limit = limits[1] + 1; }
        if (countryCode === "GBR" || countryCode === "IOM") { zipCodeRegex = new RegExp(`^[a-zA-Z0-9 ]{${limits[0]},${limits[1]}}$`); limit = limits[1]; }
        if (countryCode === "NLD") { zipCodeRegex = new RegExp("^[0-9]{4} [a-zA-Z]{2}$"); limit = 7; }
      } else {
        limit = limits[1];
      }
    }
    setZipRegex(zipCodeRegex);
    setZipCodeLimit(limit);
    return { zipCodeRegex };
  };

  const upsertHistoricalAddress = (formatted) => {
    if (!formatted) return;
    if (
      historicalAddressDetails?.historicalAddressDetails &&
      !historicalAddressDetails.historicalAddressDetails.some((a) => a.toLowerCase() === formatted.toLowerCase())
    ) {
      historicalAddressDetails.setHistoricalAddressDetails([...historicalAddressDetails.historicalAddressDetails, formatted]);
    }
  };

  // ── Data fetching ──────────────────────────────────────────────────────

  const getCountries = async () => {
    let countryOptions = [], allCountryStateOptions = null;
    const countryListResponse = countryListDetails?.countryListDetails ? countryListDetails.countryListDetails : await getCountryList();
    if (countryListResponse.status === 200 && countryListResponse?.data?.data?.length) {
      countryOptions = countryListResponse.data.data;
      countryListDetails.setCountryListDetails(countryListResponse);
      ({ allCountryStateOptions } = await getStateListData());
    } else {
      notify("Unable to fetch country list due to an unexpected error", "error");
    }
    setAddress((prev) => ({
      ...prev,
      country: { ...prev.country, options: countryOptions, error: !countryOptions.length, errorText: countryOptions.length ? prev.country.errorText : "Unable to fetch country list due to an unexpected error", success: false },
      state: { ...prev.state, options: [], allStateOptions: allCountryStateOptions, error: !allCountryStateOptions, errorText: allCountryStateOptions ? prev.state.errorText : "Unable to fetch state list due to an unexpected error", success: false },
    }));
    return { countryOptions, allCountryStateOptions };
  };

  const getStateListData = async () => {
    let allCountryStateOptions = null;
    const stateListResponse = stateListDetails.stateListDetails ? stateListDetails.stateListDetails : await getStatesList();
    if (stateListResponse.status === 200 && stateListResponse?.data?.data?.length) {
      stateListDetails.setStateListDetails(stateListResponse);
      allCountryStateOptions = stateListResponse.data.data.map((st) => ({ ...st, stateName: st.erpStateCode + " - " + st.stateCode }));
      allCountryStateOptions = groupBy(allCountryStateOptions, "countryCode");
    } else {
      notify("Unable to fetch state list due to an unexpected error", "error");
    }
    return { allCountryStateOptions };
  };

  // ── Field handlers ─────────────────────────────────────────────────────

  const handleAddressFields = (field, value, customValue1 = false, customValue2 = false, countryOptions = false, allCountryStateOptions = false, trim = false) => {
    if (!trim && verified) {
      setAddress((prev) => ({ ...prev, verified: false }));
    }
    switch (field) {
      case "Address 1": {
        if (value && value.length && value.toLowerCase() !== "null") {
          ADDRESS_REGEX.test(value)
            ? setAddress((prev) => ({ ...prev, address1: { value, error: false, errorText: "Enter address 1", success: true } }))
            : setAddress((prev) => ({ ...prev, address1: { value, error: true, errorText: "Enter a valid address 1", success: false } }));
        } else {
          setAddress((prev) => ({ ...prev, address1: { value: "", error: true, errorText: "Enter address 1", success: false } }));
        }
        break;
      }
      case "Address 2": {
        if (value && value.length && value.toLowerCase() !== "null") {
          ADDRESS_REGEX.test(value)
            ? setAddress((prev) => ({ ...prev, address2: { value, error: false, errorText: "Enter address 2", success: true } }))
            : setAddress((prev) => ({ ...prev, address2: { value, error: true, errorText: "Enter a valid address 2", success: false } }));
        } else {
          setAddress((prev) => ({ ...prev, address2: { value: "", error: false, errorText: "Enter address 2", success: false } }));
        }
        break;
      }
      case "City": {
        value && value.length && value.toLowerCase() !== "null"
          ? ADDRESS_REGEX.test(value)
            ? setAddress((prev) => ({ ...prev, city: { ...prev.city, value, error: false, errorText: "Enter city", success: true } }))
            : setAddress((prev) => ({ ...prev, city: { ...prev.city, value, error: true, errorText: "Enter valid city", success: false } }))
          : setAddress((prev) => ({ ...prev, city: { ...prev.city, value: "", error: true, errorText: "Enter city", success: false } }));
        break;
      }
      case "State": {
        value = customValue1.find((st) => value === st.erpStateCode || value?.toLowerCase() === st.stateCode.toLowerCase()) ?? null;
        value
          ? setAddress((prev) => ({ ...prev, state: { ...prev.state, value, error: false, errorText: "Please select state", success: true } }))
          : setAddress((prev) => ({ ...prev, state: { ...prev.state, value: null, error: true, errorText: "Please select state", success: false } }));
        break;
      }
      case "Zip": {
        value = value.replace(/[^a-zA-Z0-9 ]/g, "");
        if (value && value.length && value.toLowerCase() !== "null") {
          customValue1.test(value)
            ? setAddress((prev) => ({ ...prev, zip: { value, error: false, errorText: "Enter zip code", success: true } }))
            : setAddress((prev) => ({ ...prev, zip: { value, error: true, errorText: "Enter a valid zip code", success: false } }));
        } else {
          setAddress((prev) => ({ ...prev, zip: { value: "", error: true, errorText: "Enter zip code", success: false } }));
        }
        break;
      }
      case "Country": {
        countryOptions = countryOptions || country.options;
        let stateOptions = allCountryStateOptions || state.allStateOptions;
        value = countryOptions.find((c) => c.code.toLowerCase() === value?.toLowerCase() || c.description.toLowerCase() === value?.toLowerCase()) ?? null;
        const { zipCodeRegex } = handleZipCodeBasedOnCountry(value?.code ?? null);
        if (value) {
          stateOptions = stateOptions ? stateOptions[value.code] : [];
          setAddress((prev) => ({
            ...prev,
            country: { ...prev.country, value, error: false, errorText: "Please select country", success: true },
            state: { ...prev.state, value: null, options: stateOptions, error: !stateOptions.length || prev.state.value || prev.state.error ? true : false, success: false },
          }));
          stateOptions.length && customValue1 && handleAddressFields("State", customValue1, stateOptions);
        } else {
          setAddress((prev) => ({
            ...prev,
            country: { ...prev.country, value: null, error: true, errorText: prev.country.error ? prev.country.errorText : "Please select country", success: false },
            state: { ...prev.state, value: null, options: [], error: prev.state.value || prev.state.error ? true : false, success: false },
          }));
        }
        customValue2 ? handleAddressFields("Zip", customValue2, zipCodeRegex) : zip.value && handleAddressFields("Zip", zip.value, zipCodeRegex);
        break;
      }
    }
  };

  // ── Initialization ─────────────────────────────────────────────────────

  const handleAddress = async () => {
    if (isEditVehicle) {
      if (vehicleData && Object.keys(vehicleData).length) {
        setAddress((prev) => ({ ...prev, historicalAddress: { value: shippingAddress, error: false, errorText: "", success: true } }));
        handleAddressFields("Address 1", vehicleData.addressOne?.trim());
        handleAddressFields("Address 2", vehicleData.addressTwo?.trim());
        handleAddressFields("City", vehicleData.city?.trim());
        handleAddressFields("Country", vehicleData.country?.trim(), vehicleData.stateCode?.trim(), vehicleData.zipCode?.trim());
        setAddress((prev) => ({ ...prev, addressByPass: "NeedToValidateOnLoad" }));
      }
      return;
    }
    setLoader(true);
    if (showInternalLoader) setInternalLoader(true);
    let countryOptions = [], allCountryStateOptions = null;
    if (address.country.value && address.country.options.length) {
      countryOptions = address.country.options;
      handleZipCodeBasedOnCountry(address.country.value.code);
      if (address.state.value && address.state.options.length && address.state.allStateOptions) allCountryStateOptions = address.state.allStateOptions;
    } else {
      ({ countryOptions, allCountryStateOptions } = await getCountries());
    }
    setLoader(false);
    if (showInternalLoader) setInternalLoader(false);

    if (vehicleData && Object.keys(vehicleData).length) {
      setAddress((prev) => ({ ...prev, historicalAddress: { value: "Please select an address or choose Add New to add a new address", error: false, errorText: "", success: true } }));
      handleAddressFields("Address 1", vehicleData.addressOne?.trim());
      handleAddressFields("Address 2", vehicleData.addressTwo?.trim());
      handleAddressFields("City", vehicleData.city?.trim());
      handleAddressFields("Country", vehicleData.country?.trim(), vehicleData.stateCode?.trim(), vehicleData.zipCode?.trim(), countryOptions, allCountryStateOptions);
      setAddress((prev) => ({ ...prev, addressByPass: "NeedToValidateOnLoad" }));
    }
    if (defaultCountryOnInit && countryOptions.length && !address.country.value) {
      handleAddressFields("Country", defaultCountryOnInit, false, false, countryOptions, allCountryStateOptions);
    }
  };

  const validateAndSetShippingAddress = async (addressToValidate) => {
    if (!addressToValidate || addressToValidate.trim() === "") return;
    if (isEditVehicle) setIsValidatingHistoricalAddress(true);
    if (showInternalLoader) setInternalLoader(true);
    setAddress((prev) => ({ ...prev, historicalAddress: { value: addressToValidate, error: false, errorText: "", success: true } }));
    setSelectedAddressType(addressToValidate);
    const splitted = splitAddress(addressToValidate);
    try {
      const data = { inputAddress: { addressLine1: splitted.address1, addressLine2: splitted.address2, city: splitted.city, stateProvince: splitted.state, postalCode: splitted.zipCode, country: splitted.country } };
      const response = await validateAddress(data);
      if (response?.status === 200 && response?.data?.message.toLowerCase() === "success") {
        const rd = response.data.data;
        setAddress((prev) => ({
          ...prev,
          address1: { value: splitted.address1, error: false, errorText: "Enter address 1", success: true },
          address2: { value: splitted.address2, error: false, errorText: "Enter address 2", success: false },
          city: { value: splitted.city, error: false, errorText: "Enter city", success: true },
          state: { ...prev.state, value: splitted.state, error: false, errorText: "Please select state", success: true },
          country: { ...prev.country, value: { code: splitted.country }, error: false, errorText: "Please select country", success: true },
          countryCode: splitted.country,
          zip: { value: splitted.zipCode, error: false, errorText: "Enter zip code", success: true },
          verified: true, addressByPass: rd.addressByPass, locationFound: rd.locationFound, timezone: rd.location?.timezone || "",
          ...(trackLocusFields ? { latitude: rd.standardizedInfo?.standardizedAddress?.latLong?.latitude || "", longitude: rd.standardizedInfo?.standardizedAddress?.latLong?.longitude || "", locusSuggestedAddress: rd.standardizedInfo?.standardizedAddress?.formattedAddress, locusLocationId: rd.location?.locationId, dpv: rd.location?.dpv || "" } : {}),
        }));
      } else if (response?.data?.data?.errors || response?.response?.data?.message === "Unable to validate address") {
        notify("Address validation failed", "error");
      } else if (isEditVehicle) {
        setModalOpened?.(false);
        setAlertModal?.(true);
      }
    } catch (error) {
      if (isEditVehicle) { setModalOpened?.(false); setAlertModal?.(true); }
    } finally {
      if (isEditVehicle) setIsValidatingHistoricalAddress(false);
    }
    if (showInternalLoader) setInternalLoader(false);
    setLoader(false);
  };

  // ── Address verification ───────────────────────────────────────────────

  const handleAddressVerification = async (addressData) => {
    if (!isEditVehicle) { setLoader(true); if (showInternalLoader) setInternalLoader(true); }
    else { setIsValidatingNewAddress(true); }
    showHistoricalAddressDropdown && !isAddressFieldsDisable && setIsAddressFieldsDisable(true);
    !isAddressValidationBtnDisabled && setIsAddressValidationBtnDisabled(true);

    const data = { inputAddress: { addressLine1: addressData?.address1?.value, addressLine2: addressData?.address2?.value ?? "", city: addressData?.city?.value, stateProvince: addressData?.state?.value?.erpStateCode, postalCode: addressData?.zip?.value, country: addressData?.country?.value?.code } };
    try {
    const response = await validateAddress(data);
    let timezone = "", latitude = "", longitude = "", locusSuggestedAddress = "", locusLocationId = "", dpv = "";

    if (response?.status === 200 && response?.data?.message.toLowerCase() === "success") {
      const rd = response?.data?.data, byPass = rd?.addressByPass, locFound = rd?.locationFound,
        stdAddr = rd?.standardizedInfo?.standardizedAddress, userAddr = rd?.inputAddress,
        stdNorm = { address1: stdAddr?.addressLine1?.toLowerCase(), address2: stdAddr?.subLocation?.toLowerCase() ?? "", city: stdAddr?.city?.toLowerCase(), state: stdAddr?.stateProvince?.toLowerCase(), zip: stdAddr?.postalCodeBase?.toLowerCase(), country: stdAddr?.iso3CountryCode?.toLowerCase() },
        userNorm = { address1: userAddr?.addressLine1?.toLowerCase(), address2: userAddr?.addressLine2?.toLowerCase() ?? "", city: userAddr?.city?.toLowerCase(), state: userAddr?.stateProvince?.toLowerCase(), zip: userAddr?.postalCode?.toLowerCase(), country: userAddr?.country?.toLowerCase() },
        isExactMatch = isEqual(stdNorm, userNorm);

      timezone = rd?.location?.timezone ?? "";
      if (trackLocusFields) {
        latitude = rd?.standardizedInfo?.standardizedAddress?.latLong?.latitude ?? "";
        longitude = rd?.standardizedInfo?.standardizedAddress?.latLong?.longitude ?? "";
        locusSuggestedAddress = `${stdAddr?.addressLine1}, ${stdAddr?.subLocation ? stdAddr?.subLocation + ", " : ""}${stdAddr?.city}, ${stdAddr?.stateProvince}, ${stdAddr?.postalCodeBase}, ${stdAddr?.iso3CountryCode}`;
        locusLocationId = rd?.location?.locationId ?? "";
        dpv = rd?.location?.dpv ?? "";
      }

      if (byPass === "YES") {
        setAddress((prev) => ({ ...prev, verified: true, ...(trackLocusFields ? { locusLocationId, dpv } : {}) }));
        if (!locFound) notify("Please note that the entered address is not verified and couldn't find a close match", "warning");
      } else if (locFound) {
        if (isExactMatch) {
          setAddress((prev) => ({ ...prev, verified: true, ...(trackLocusFields ? { locusLocationId, dpv } : {}) }));
          if ((autoValidateShippingAddress || isEditVehicle) && historicalAddress.value === "Add New") {
            const fmtNew = `${addressData.address1.value}, ${addressData.address2.value ? addressData.address2.value + ", " : ""}${addressData.city.value}, ${addressData.state.value?.erpStateCode || addressData.state.value?.stateCode || ""}, ${addressData.zip.value}, ${addressData.country.value?.code}`;
            upsertHistoricalAddress(fmtNew);
            setAddress((prev) => ({ ...prev, historicalAddress: { ...prev.historicalAddress, value: fmtNew }, ...(trackLocusFields ? { locusLocationId, dpv } : {}) }));
            setSelectedAddressType(fmtNew);
          }
        } else {
          setIsAddressSuggestionShown(true);
          setSuggestedAddress({
            address: `${stdAddr?.addressLine1}, ${stdAddr?.subLocation ? stdAddr?.subLocation + ", " : ""}${stdAddr?.city}, ${stdAddr?.stateProvince}, ${stdAddr?.postalCodeBase}, ${stdAddr?.iso3CountryCode}`,
            address1: stdAddr?.addressLine1, address2: stdAddr?.subLocation, city: stdAddr?.city, state: stdAddr?.stateProvince, zip: stdAddr?.postalCodeBase, country: stdAddr?.iso3CountryCode,
            ...(trackLocusFields ? { locusLocationId, dpv } : {}),
          });
          setTypedAddress(`${userAddr.addressLine1}, ${userAddr.addressLine2 ? userAddr.addressLine2 + ", " : ""}${userAddr.city}, ${userAddr.stateProvince}, ${userAddr.postalCode}, ${userAddr.country}`);
        }
      } else {
        notify("We couldn't verify the entered address and couldn't find a close match", "error");
        if (isEditVehicle) setIsAddressFieldsDisable(false);
      }

      const locusExtra = trackLocusFields ? { latitude, longitude, locusSuggestedAddress, locusLocationId, dpv } : {};
      if (shippingAddress && !isEditVehicle) {
        const entered = [addressData?.address1?.value, addressData?.address2?.value, addressData?.city?.value, addressData?.state?.value?.erpStateCode, addressData?.zip?.value, addressData?.country?.value?.code].filter((item) => item !== null && item !== "").join(", ");
        setAddress((prev) => ({ ...prev, addressByPass: byPass, locationFound: locFound, timezone, ...locusExtra, isDefaultAddress: entered.toLowerCase() === shippingAddress.toLowerCase() }));
      } else {
        setAddress((prev) => ({ ...prev, addressByPass: byPass, locationFound: locFound, timezone, ...locusExtra }));
      }
      if (isEditVehicle) setHandleInvalidAddress(false);
      if (onVerificationComplete) onVerificationComplete(response);
    } else {
      const locusExtra = trackLocusFields ? { latitude, longitude, locusSuggestedAddress, locusLocationId, dpv } : {};
      setAddress((prev) => ({ ...prev, timezone, ...locusExtra }));
      if (setValidAddress) setValidAddress({ isNewAddress: true });
      notify("Address validation failed due to an unexpected error", "error");
    }
    } catch (error) {
      if (isEditVehicle) notify("Error validating address", "error");
    } finally {
      if (isEditVehicle) setIsValidatingNewAddress(false);
    }
    if (!isEditVehicle) { setLoader(false); if (showInternalLoader) setInternalLoader(false); }
  };

  // ── Address selection (suggested vs typed) ─────────────────────────────

  const handleAddressSelection = (isVerified = false) => {
    if (isVerified) {
      const fmt = `${suggestedAddress.address1}, ${suggestedAddress.address2 ? suggestedAddress.address2 + ", " : ""}${suggestedAddress.city}, ${suggestedAddress.state}, ${suggestedAddress.zip}, ${suggestedAddress.country}`;
      upsertHistoricalAddress(fmt);
      setSelectedAddressType(fmt);
      const locusExtra = trackLocusFields && suggestedAddress.locusLocationId ? { locusLocationId: suggestedAddress.locusLocationId, dpv: suggestedAddress.dpv } : {};
      const isDefault = shippingAddress ? fmt === shippingAddress : undefined;
      setAddress((prev) => ({ ...prev, historicalAddress: { value: fmt, error: false, errorText: "", success: true }, verified: true, ...locusExtra, ...(isDefault !== undefined ? { isDefaultAddress: isDefault } : {}) }));
      handleAddressFields("Address 1", suggestedAddress.address1);
      handleAddressFields("Address 2", suggestedAddress.address2);
      handleAddressFields("City", suggestedAddress.city);
      handleAddressFields("Country", suggestedAddress.country, suggestedAddress.state, suggestedAddress.zip);
    }
    setIsAddressSuggestionShown(false);
    setSuggestedAddress({ address: "", address1: "", address2: "", city: "", state: "", zip: "", country: "" });
    setTypedAddress("");
  };

  // ── Historical address selection ───────────────────────────────────────

  const handleHistoricalAddressSelection = async (addressSelected) => {
    if (shippingAddress && !isEditVehicle) setAddress((prev) => ({ ...prev, isDefaultAddress: addressSelected === shippingAddress }));
    if (setValidAddress) setValidAddress({ isNewAddress: addressSelected === "Add New", selectedAddress: addressSelected });
    if (selectedAddressType && addressSelected === selectedAddressType) return;

    if (isEditVehicle && addressSelected === shippingAddress) {
      setIsValidatingHistoricalAddress(true);
      try {
        const stateValue = state.allStateOptions?.[originalValues.country]?.find((s) => s.stateCode === originalValues.state || s.erpStateCode === originalValues.state) || null;
        const stateOptions = state.allStateOptions?.[originalValues.country] || [];
        setAddress((prev) => ({
          ...prev,
          address1: { value: originalValues.address1, error: false, errorText: "Enter address 1", success: true },
          address2: { value: originalValues.address2, error: false, errorText: "Enter address 2", success: false },
          city: { value: originalValues.city, error: false, errorText: "Enter city", success: true },
          country: { ...prev.country, value: country.options.find((c) => c.code === originalValues.country) || null, error: false, success: true },
          state: { ...prev.state, value: stateValue?.erpStateCode, options: stateOptions, error: false, success: true },
          zip: { value: originalValues.zipCode, error: false, errorText: "Enter zip code", success: true },
          historicalAddress: { value: addressSelected, error: false, errorText: "", success: true },
          verified: true,
        }));
        setIsAddressFieldsDisable(true);
        setSelectedAddressType(addressSelected);
      } finally {
        setTimeout(() => setIsValidatingHistoricalAddress(false), 500);
      }
      return;
    }

    if (addressSelected === "Add New") {
      setAddress((prev) => ({
        ...prev,
        address1: { value: "", error: false, errorText: "Enter address 1", success: false },
        address2: { value: "", error: false, errorText: "Enter address 2", success: false },
        city: { value: "", error: false, errorText: "Enter city", success: false },
        state: { ...prev.state, value: null, options: [], error: !prev.state.allStateOptions, errorText: prev.state.options.length ? "Please select state" : prev.state.errorText, success: false },
        zip: { value: "", error: false, errorText: "Enter zip code", success: false },
        country: { ...prev.country, value: null, error: !prev.country.options.length, errorText: prev.country.options.length ? "Please select country" : prev.country.errorText, success: false },
        historicalAddress: { value: isEditVehicle ? "Add New" : "Please select an address or choose Add New to add a new address", error: false, errorText: "", success: false },
        verified: false,
      }));
      if (defaultCountryOnNew) {
        handleAddressFields("Country", defaultCountryOnNew);
        setAddress((prev) => ({ ...prev, zip: { value: "", error: false, errorText: "Enter zip code", success: false } }));
      }
      setSelectedAddressType("Add New");
    } else {
      if (isEditVehicle) {
        setIsValidatingHistoricalAddress(true);
        setHandleInvalidAddress(true);
      }
      const splitted = splitAddress(addressSelected);
      handleAddressFields("Address 1", splitted.address1);
      handleAddressFields("Address 2", splitted.address2);
      handleAddressFields("City", splitted.city);
      handleAddressFields("Country", splitted.country, splitted.state, splitted.zipCode);
      setAddress((prev) => ({ ...prev, historicalAddress: { value: addressSelected, error: false, errorText: "", success: true }, verified: false }));
      setSelectedAddressType(addressSelected);
      if (isEditVehicle) {
        try {
          const valData = { inputAddress: { addressLine1: splitted.address1, addressLine2: splitted.address2, city: splitted.city, stateProvince: splitted.state, postalCode: splitted.zipCode, country: splitted.country } };
          const response = await validateAddress(valData);
          if (response?.status === 200 && response?.data?.message.toLowerCase() === "success") {
            const rd = response.data.data;
            setAddress((prev) => ({ ...prev, verified: true, addressByPass: rd.addressByPass, locationFound: rd.locationFound, timezone: rd.location?.timezone || "", ...(trackLocusFields ? { latitude: rd.standardizedInfo?.standardizedAddress?.latLong?.latitude || "", longitude: rd.standardizedInfo?.standardizedAddress?.latLong?.longitude || "", locusSuggestedAddress: rd.standardizedInfo?.standardizedAddress?.formattedAddress, locusLocationId: rd.location?.locationId, dpv: rd.location?.dpv } : {}) }));
          } else {
            notify("Address validation failed", "error");
          }
        } catch { notify("Error validating address", "error"); }
        finally { setTimeout(() => setIsValidatingHistoricalAddress(false), 500); }
      }
    }
  };

  // ── Effects ────────────────────────────────────────────────────────────

  useEffect(() => {
    handleAddress();
    if (isEditVehicle && shippingAddress) validateAndSetShippingAddress(shippingAddress);
    else if (autoValidateShippingAddress && shippingAddress) validateAndSetShippingAddress(shippingAddress);
  }, []);

  useEffect(() => {
    if (!isEditVehicle || !originalValues.address1) return;
    const fieldsChanged = historicalAddress.value !== originalValues.historicalAddress;
    if (onFieldsChanged) {
      onFieldsChanged(fieldsChanged, {
        isAddressValidated: verified,
        isAddressNewAndNotValidated: historicalAddress.value === "Add New" && !verified,
      });
    }
  }, [historicalAddress.value, verified]);

  useEffect(() => {
    if (address1.success && !address2.error && city.success && state.success && country.success && zip.success) {
      if (verified) {
        historicalAddress.value.includes("Please") ? isAddressFieldsDisable && setIsAddressFieldsDisable(false) : showHistoricalAddressDropdown && !isAddressFieldsDisable && setIsAddressFieldsDisable(true);
      } else {
        if (vehicleData?.id && addressByPass === "NeedToValidateOnLoad") {
          if (!vehicleData?.addressByPass) { handleAddressVerification(address); }
          else { setAddress((prev) => ({ ...prev, verified: true, addressByPass: vehicleData.addressByPass, locationFound: vehicleData.locationFound })); }
        } else if (isAddressSuggestionShown) {
          showHistoricalAddressDropdown && !isAddressFieldsDisable && setIsAddressFieldsDisable(true);
          !isAddressValidationBtnDisabled && setIsAddressValidationBtnDisabled(true);
          if (!suggestedAddress.address && isAddressSuggestionShown) { setIsAddressSuggestionShown(false); setAddress((prev) => ({ ...prev, verified: true })); }
        } else if (!historicalAddress.value.includes("Please") && historicalAddress.success) {
          handleAddressVerification(address);
        } else {
          isAddressFieldsDisable && setIsAddressFieldsDisable(false);
          isAddressValidationBtnDisabled && setIsAddressValidationBtnDisabled(false);
        }
      }
    } else {
      if (addressByPass === "NeedToValidateOnLoad") { setAddress((prev) => ({ ...prev, addressByPass: null })); }
      else if (!suggestedAddress.address && isAddressSuggestionShown) { setIsAddressSuggestionShown(false); setAddress((prev) => ({ ...prev, verified: false })); }
      else {
        if (!historicalAddress.value) { showHistoricalAddressDropdown && !isAddressFieldsDisable && setIsAddressFieldsDisable(true); }
        else {
          !historicalAddress.value.includes("Please") && setAddress((prev) => ({ ...prev, historicalAddress: { ...prev.historicalAddress, error: true, success: false } }));
          isAddressFieldsDisable && setIsAddressFieldsDisable(false);
          !isAddressValidationBtnDisabled && setIsAddressValidationBtnDisabled(true);
        }
      }
    }
  }, [verified, historicalAddress.value, addressByPass, address1.value, address2.value, country.value, city.value, state.value, zip.value, suggestedAddress.address]);

  // ── Render helpers ─────────────────────────────────────────────────────

  const isKeyfob = variant === "keyfob";
  const InputComp = isKeyfob ? Input : CustomInput;
  const SelectComp = isKeyfob ? DropdownSelect : CustomDropdown;
  const radioWidth = styles.radioGroupWidth || (variant === "vehicle" ? "100%" : "70vmin");
  const isFieldsDisabled = isKeyfob ? verified : isAddressFieldsDisable;

  const shouldShowFields = (() => {
    if (isKeyfob && validAddress) return (validAddress.isNewAddress || (!validAddress.isNewAddress && !verified)) && !!validAddress?.selectedAddress?.length;
    if (variant === "vehicle" || variant === "wt") return selectedAddressType === "Add New" || (!isAddressFieldsDisable && !verified);
    if (isEditVehicle) return selectedAddressType === "Add New" || (!isAddressFieldsDisable && (isErrorInAddressFields || handleInvalidAddress));
    return true;
  })();

  const countryOptions = (<><option disabled>Please Select</option>{country.options.map((c) => (<option key={c.code}>{c.code}</option>))}</>);
  const stateOptionsEl = (<><option disabled style={{ backgroundColor: "lightgrey" }}>Please Select</option>{state.options.map((sc) => (<option key={sc.stateCode + sc.countryCode}>{sc.stateName}</option>))}</>);

  const addr1Props = { type: "text", label: "Address 1", "aria-label": "Address 1", error: address1.error, errorText: address1.errorText, success: address1.success, value: address1.value, disabled: isFieldsDisabled, onChange: (e) => handleAddressFields("Address 1", e.target.value), onBlur: (e) => handleAddressFields("Address 1", e.target.value?.trim(), false, false, false, false, true) };
  const addr2Props = { type: "text", label: "Address 2 (Optional)", "aria-label": "Address 2 (Optional)", error: address2.error, errorText: address2.errorText, success: address2.success, value: address2.value, disabled: isFieldsDisabled, onChange: (e) => handleAddressFields("Address 2", e.target.value), onBlur: (e) => handleAddressFields("Address 2", e.target.value?.trim(), false, false, false, false, true) };
  const cityProps = { width: "100%", type: "text", label: "City", "aria-label": "City", paddingRight: "5px", error: city.error, errorText: city.errorText, success: city.success, value: city.value, disabled: isFieldsDisabled, onChange: (e) => handleAddressFields("City", e.target.value), css: ColumnAlignment, onBlur: (e) => handleAddressFields("City", e.target.value?.trim(), false, false, false, false, true) };
  const countryFieldProps = { width: "100%", type: "text", label: "Country", "aria-label": "Country", hideErrorImg: country.error, paddingRight: "5px", css: ColumnAlignment, error: country.error, errorText: country.errorText, success: country.success, value: country.value?.code || "Please Select", disabled: isFieldsDisabled, onChange: (e) => handleAddressFields("Country", e.target.value, false, false) };
  const stateFieldProps = { width: "100%", paddingRight: "5px", type: "text", label: "State", "aria-label": "State", disabled: isFieldsDisabled || !country.value, hideErrorImg: state.error, error: state.error, errorText: state.errorText, value: state.value?.stateName || "Please Select", onChange: (e) => handleAddressFields("State", e.target.value.split(" - ")[0], state.options) };
  const zipFieldProps = { width: "100%", type: "text", label: "Zip/Postal Code", "aria-label": "Zip", error: zip.error, errorText: zip.errorText, value: zip.value, success: zip.success, disabled: isFieldsDisabled || !country.value, onChange: (e) => handleAddressFields("Zip", e.target.value, zipRegex), maxLength: zipCodeLimit, onBlur: (e) => handleAddressFields("Zip", e.target.value?.trim(), zipRegex, false, false, false, true) };

  const renderFormFields = () => {
    if (isEditVehicle) {
      return (
        <>
          <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto", marginTop: "4px" }}>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><Input {...addr1Props} /></Col>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><Input {...addr2Props} /></Col>
          </Row>
          <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><Input {...cityProps} /></Col>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><DropdownSelect {...countryFieldProps}>{countryOptions}</DropdownSelect></Col>
          </Row>
          <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><DropdownSelect {...stateFieldProps}>{stateOptionsEl}</DropdownSelect></Col>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><Input {...zipFieldProps} /></Col>
          </Row>
        </>
      );
    }
    if (isKeyfob) {
      return (
        <>
          <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto", marginTop: "4px" }}>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><InputComp {...addr1Props} /></Col>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><InputComp {...addr2Props} /></Col>
          </Row>
          <Row css={{ marginTop: "10px", flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><InputComp {...cityProps} /></Col>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><SelectComp {...countryFieldProps}>{countryOptions}</SelectComp></Col>
          </Row>
          <Row css={{ marginTop: "10px", flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><SelectComp {...stateFieldProps}>{stateOptionsEl}</SelectComp></Col>
            <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}><InputComp {...zipFieldProps} /></Col>
          </Row>
        </>
      );
    }
    if (variant === "wt") {
      return (
        <SLGridLayout>
          <SLRowLayout css={{ marginTop: ".5rem", paddingLeft: "10px !important" }}><CompactCol colSizes={{ mobile: 2, tablet: 6, desktop: 12 }}><InputComp {...addr1Props} width="102%" /></CompactCol></SLRowLayout>
          <SLRowLayout css={{ paddingLeft: "10px !important" }}><CompactCol colSizes={{ mobile: 2, tablet: 6, desktop: 12 }}><InputComp {...addr2Props} width="102%" /></CompactCol></SLRowLayout>
          <SLRowLayout css={{ paddingLeft: "10px !important" }}>
            <CompactCol colSizes={{ mobile: 2, tablet: 6, desktop: 14 }} css={WTStyledCol}>
              <SLGridLayout><SLRowLayout css={{ paddingLeft: "10px !important" }}>
                <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}><SelectComp {...countryFieldProps}>{countryOptions}</SelectComp></CompactCol>
                <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}><SelectComp {...stateFieldProps}>{stateOptionsEl}</SelectComp></CompactCol>
              </SLRowLayout></SLGridLayout>
            </CompactCol>
          </SLRowLayout>
          <SLRowLayout css={{ paddingLeft: "10px !important", marginTop: "0.3rem" }}>
            <CompactCol colSizes={{ mobile: 2, tablet: 6, desktop: 14 }} css={WTStyledCol}>
              <SLGridLayout><SLRowLayout css={{ paddingLeft: "10px !important" }}>
                <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}><InputComp {...cityProps} /></CompactCol>
                <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}><InputComp {...zipFieldProps} /></CompactCol>
              </SLRowLayout></SLGridLayout>
            </CompactCol>
          </SLRowLayout>
        </SLGridLayout>
      );
    }
    if (variant === "vehicle") {
      return (
        <SLGridLayout>
          <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}><CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}><InputComp {...addr1Props} formWidth="100%" width="100%" /></CompactCol></SLRowLayout>
          <SLRowLayout css={{ paddingLeft: "10px !important" }}><CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}><InputComp {...addr2Props} formWidth="100%" width="100%" /></CompactCol></SLRowLayout>
          <SLRowLayout css={{ paddingLeft: "10px !important" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}><InputComp {...cityProps} formWidth="100%" width="100%" /></CompactCol>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}><SelectComp {...countryFieldProps} css={{ width: "100%" }}>{countryOptions}</SelectComp></CompactCol>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}><SelectComp {...stateFieldProps} css={{ width: "100%" }}>{stateOptionsEl}</SelectComp></CompactCol>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}><InputComp {...zipFieldProps} formWidth="100%" width="100%" /></CompactCol>
          </SLRowLayout>
        </SLGridLayout>
      );
    }
    return (
      <SLGridLayout>
        <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}><CompactCol colSizes={{ mobile: 2, tablet: 6, desktop: 6 }}><InputComp {...addr1Props} /></CompactCol></SLRowLayout>
        <SLRowLayout css={{ paddingLeft: "10px !important" }}><CompactCol colSizes={{ mobile: 2, tablet: 6, desktop: 6 }}><InputComp {...addr2Props} /></CompactCol></SLRowLayout>
        <SLRowLayout css={{ paddingLeft: "10px !important" }}>
          <CompactCol colSizes={{ mobile: 2, tablet: 6, desktop: 6 }} css={StyledCol}>
            <SLGridLayout><SLRowLayout css={{ paddingLeft: "10px !important" }}>
              <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}><InputComp {...cityProps} /></CompactCol>
              <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}><SelectComp {...countryFieldProps}>{countryOptions}</SelectComp></CompactCol>
              <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}><SelectComp {...stateFieldProps}>{stateOptionsEl}</SelectComp></CompactCol>
              <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 3 }}><InputComp {...zipFieldProps} /></CompactCol>
            </SLRowLayout></SLGridLayout>
          </CompactCol>
        </SLRowLayout>
      </SLGridLayout>
    );
  };

  const renderHistoricalDropdown = () => {
    if (!showHistoricalAddressDropdown) return null;
    const dropdownValue = variant === "wt" ? selectedAddressType : (historicalAddress.value || "Please select an address or choose Add New to add a new address");

    if (isEditVehicle) {
      const isValidAddress = (addr) => {
        if (!addr || addr.trim() === "" || addr.trim().startsWith(",")) return false;
        return addr.split(",").filter((p) => p.trim() !== "").length >= 4;
      };
      const allAddresses = [];
      if (isValidAddress(shippingAddress)) allAddresses.push(shippingAddress);
      if (historicalAddressDetails?.historicalAddressDetails?.length > 0) {
        historicalAddressDetails.historicalAddressDetails.forEach((addr) => {
          if (isValidAddress(addr) && !allAddresses.some((a) => a.toLowerCase() === addr.toLowerCase())) allAddresses.push(addr);
        });
      }
      return (
        <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
          <Col css={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <DropdownSelect
              style={{ width: "100%" }}
              label={"Shipping Address *"}
              type="text"
              aria-label={selectedAddressType}
              value={selectedAddressType}
              disabled={isValidatingHistoricalAddress || isValidatingNewAddress}
              onChange={(e) => handleHistoricalAddressSelection(e.target.value)}
            >
              {allAddresses.length > 0 ? (
                <>{allAddresses.map((addr) => (<option key={generate()}>{addr}</option>))}<option>Add New</option></>
              ) : (
                <><option disabled>No Address Available</option><option>Add New</option></>
              )}
            </DropdownSelect>
          </Col>
        </Row>
      );
    }

    if (isKeyfob) {
      return (
        <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
          <Col css={{ flex: 3, display: "flex", flexDirection: "column" }}>
            <DropdownSelect style={{ width: "100%" }} label="Shipping Address *" data-testid="select-shipping-address" type="text" disabled={!country.options.length || !state.allStateOptions} aria-label={historicalAddress.value || "Please select an address or choose Add New to add a new address"} value={historicalAddress.value || "Please select an address or choose Add New to add a new address"} onChange={(e) => handleHistoricalAddressSelection(e.target.value)}>
              {historicalAddressDetails?.historicalAddressDetails?.length > 0 ? (<><option disabled>Please select an address or choose Add New to add a new address</option>{historicalAddressDetails.historicalAddressDetails.map((addr) => (<option key={generate()}>{addr}</option>))}<option>Add New</option></>) : (<><option disabled>Please select an address or choose Add New to add a new address</option><option disabled>No Address Available</option><option>Add New</option></>)}
            </DropdownSelect>
          </Col>
        </Row>
      );
    }

    const renderOptions = () => {
      if (variant === "wt") {
        const allAddresses = [];
        if (historicalAddressDetails?.historicalAddressDetails?.length > 0) historicalAddressDetails.historicalAddressDetails.forEach((addr) => { if (!allAddresses.some((a) => a.toLowerCase() === addr.toLowerCase())) allAddresses.push(addr); });
        return allAddresses.length > 0 ? (<>{allAddresses.map((addr) => (<option key={generate()}>{addr}</option>))}<option>Add New</option></>) : (<><option disabled>No Address Available</option><option>Add New</option></>);
      }
      return historicalAddressDetails?.historicalAddressDetails?.length > 0 ? (<><option disabled>Please select an address or choose Add New to add a new address</option>{historicalAddressDetails.historicalAddressDetails.map((addr) => (<option key={generate()}>{addr}</option>))}<option>Add New</option></>) : (<><option disabled>Please select an address or choose Add New to add a new address</option><option disabled>No Address Available</option><option>Add New</option></>);
    };

    const dropdownCss = variant === "wt" ? WTInstallationAddressRow : InstallationAddressRow;
    const colSizes = variant === "vehicle" ? { mobile: 4, tablet: 12, desktop: 12 } : undefined;

    return (
      <SLGridLayout>
        <SLRowLayout css={{ marginTop: variant === "wt" ? "-10px" : "1.25rem", paddingLeft: "10px !important" }}>
          {colSizes ? (
            <CompactCol colSizes={colSizes}><SelectComp css={{ width: "100%" }} width="100%" type="text" disabled={!country.options.length || !state.allStateOptions} aria-label={historicalAddress.value || "Please select an address or choose Add New to add a new address"} value={dropdownValue} onChange={(e) => handleHistoricalAddressSelection(e.target.value)}>{renderOptions()}</SelectComp></CompactCol>
          ) : (
            <div css={dropdownCss}><SelectComp width={variant === "wt" ? "100%" : undefined} label={variant === "wt" ? "Shipping Address" : undefined} type="text" disabled={!country.options.length || !state.allStateOptions} aria-label={historicalAddress.value || "Please select an address or choose Add New to add a new address"} value={dropdownValue} onChange={(e) => handleHistoricalAddressSelection(e.target.value)}>{renderOptions()}</SelectComp></div>
          )}
        </SLRowLayout>
      </SLGridLayout>
    );
  };

  const renderSuggestions = () => {
    if (!isAddressSuggestionShown) return null;
    const content = (
      <>
        <UltraMediumText eDSFont fontSize="18px" marginBottom="0" marginTop={variant === "wt" ? ".5rem" : "1rem"}>Choose an option</UltraMediumText>
        <SmallText>We couldn&apos;t verify the entered address. We found a close match</SmallText>
        <RadioButtonGroupWrapper $width={radioWidth}>
          <RadioButtonGroup onChange={() => handleAddressSelection(true)} error={false} data={[{ name: "group", label: (<><span>Use suggested address</span><mark css={{ fontSize: "10px", backgroundColor: "#d8dada", padding: "0rem 0.313rem", marginLeft: "0.313rem" }}>Verified</mark></>), children: suggestedAddress.address, value: "radioOne", ariaLabel: "Use suggested address" }]} />
          {showTypedAddressOption ? (
            <RadioButtonGroup onChange={() => handleAddressSelection()} error={false} data={[{ name: "group", label: <span>Use address as typed</span>, children: typedAddress, value: "radioTwo", ariaLabel: "Use address as typed" }]} />
          ) : (
            <div style={{ display: "none" }}><RadioButtonGroup onChange={() => handleAddressSelection()} error={false} data={[{ name: "group", label: <span>Use address as typed</span>, children: typedAddress, value: "radioTwo", ariaLabel: "Use address as typed" }]} /></div>
          )}
        </RadioButtonGroupWrapper>
      </>
    );
    if (variant === "vehicle") {
      return (<SLGridLayout><SLRowLayout css={{ paddingLeft: "10px !important" }}><CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>{content}</CompactCol></SLRowLayout></SLGridLayout>);
    }
    if (isEditVehicle) {
      return (
        <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto" }}>
          <Col css={{ flex: 1, display: "flex", flexDirection: "column" }}>{content}</Col>
        </Row>
      );
    }
    return content;
  };

  // ── Main render ────────────────────────────────────────────────────────

  if (isEditVehicle) {
    return (
      <>
        {renderHistoricalDropdown()}
        {isValidatingHistoricalAddress && (
          <FlexColumn css={CustomHistoricalLoader}>
            <Loader active fullscreen={false} />
            <SmallText bold css={{ paddingLeft: "2rem" }}>Verifying address...</SmallText>
          </FlexColumn>
        )}
        <div
          style={{
            height: shouldShowFields ? "auto" : "0",
            opacity: shouldShowFields ? 1 : 0,
            transition: "height 0.5s ease-out, opacity 0.3s ease-in",
            overflow: "hidden",
            transformOrigin: "top",
            animation: shouldShowFields ? "slideDown 0.5s ease-out forwards" : "",
            marginBottom: shouldShowFields ? "20px" : "0",
          }}
        >
          <style>{`@keyframes slideDown { from { height: 0; opacity: 0; transform: translateY(-20px); } to { height: auto; opacity: 1; transform: translateY(0); } }`}</style>
          {shouldShowFields ? renderFormFields() : null}
          <Row css={{ flexDirection: "row", justifyContent: "start", display: "flex !important", flex: "auto", marginTop: "10px", marginLeft: "2px" }}>
            {!isAddressFieldsDisable && (!verified || isErrorInAddressFields || handleInvalidAddress) && (
              <Button
                size="medium"
                width={120}
                primary
                css={{ paddingLeft: "10px", paddingRight: "10px" }}
                aria-label="Validate Address"
                role="button"
                onClick={() => handleAddressVerification(address)}
                disabled={isAddressValidationBtnDisabled || isValidatingNewAddress}
                aria-disabled={isAddressValidationBtnDisabled || isValidatingNewAddress}
              >
                {isValidatingNewAddress ? "Validating..." : "Validate Address"}
              </Button>
            )}
          </Row>
          {isValidatingNewAddress && selectedAddressType === "Add New" && (
            <FlexColumn css={CustomHistoricalLoader}>
              <Loader active fullscreen={false} />
              <SmallText bold css={{ paddingLeft: "2rem" }}>Validating address...</SmallText>
            </FlexColumn>
          )}
        </div>
        {renderSuggestions()}
      </>
    );
  }

  return (
    <>
      {showInternalLoader && <Loader active={isLoading} fullscreen={false} />}
      {showTitle && (
        <>
          <SLGridLayout><SLRowLayout css={{ paddingLeft: "10px !important" }}><UltraMediumText css={{ marginTop: "1.25rem" }} eDSFont fontSize="18px" marginBottom="0.7rem">{title}</UltraMediumText></SLRowLayout></SLGridLayout>
          {subTitle && (<SLGridLayout><SLRowLayout css={{ paddingLeft: "10px !important" }}><UltraMediumText css={{ marginTop: "1rem", fontWeight: "normal" }} eDSFont fontSize="14px" marginBottom="0.7rem">{subTitle}</UltraMediumText></SLRowLayout></SLGridLayout>)}
        </>
      )}
      {renderHistoricalDropdown()}
      {shouldShowFields && renderFormFields()}
      {isKeyfob ? (
        shouldShowFields && (
          <FlexRow><CustomSLButton aria-label="Validate Address" role="button" onClick={() => handleAddressVerification(address)} disabled={isAddressValidationBtnDisabled} aria-disabled={isAddressValidationBtnDisabled}>Validate Address</CustomSLButton></FlexRow>
        )
      ) : (
        <FlexRow style={variant === "vehicle" ? { paddingLeft: "10px" } : {}}>
          {!isAddressFieldsDisable && !verified && (<CustomSLButton aria-label="Validate Address" role="button" onClick={() => handleAddressVerification(address)} disabled={isAddressValidationBtnDisabled} aria-disabled={isAddressValidationBtnDisabled}>Validate Address</CustomSLButton>)}
        </FlexRow>
      )}
      {renderSuggestions()}
    </>
  );
};
